var exports = {
  "rS": "securityAlertLink__9bpVzP",
  "gn": "titleContainer__jdaRmY",
  "Ro": "alertTitle__oYN8yI",
  "ee": "alertNumber__ehnNHA",
  "OI": "listItemTitle__nqaTB_",
};

module.exports = exports;
